import api from "../../../utils/api";

export const dealerSearchMap = ({ maps, mapStyles, mapTarget }) => {
    const map = new maps.Map(mapTarget, {
        zoom: 1,
        center: { lat: 0, lng: 0 },
        mapTypeControl: false,
        styles: mapStyles,
    });

    return map;
};

export function submitForm(e: Event) {
    e.preventDefault();
    this.sliderReady = false;
    this.noResults = false;
    if (this.config === null) return;
    const fetchUrl = this.config?.fetchUrl;
    try {
        const postcodeInput = this.formElement.querySelector(
            "input[type='text']"
        );
        const postcode = postcodeInput.value.trim();
        const allDealersCheckbox = this.formElement.querySelector(
            "input[type='checkbox']"
        ) as HTMLInputElement;
        const allDealers = allDealersCheckbox.checked ? "1" : "0";
        api(
            fetchUrl +
                "?" +
                new URLSearchParams({
                    plz: postcode || this.postcode,
                    showAll: allDealers,
                })
        )
            .then((response: any) => {
                this.postcode = postcode;
                if (response.location.length === 0) {
                    this.noResults = true;
                }
                this.apiResponse = response;
            })
            .catch(() => {
                this.error = true;
            });
    } catch (e) {
        this.error = true;
    }
}

export function changePostcode() {
    const postcodeElement = document.querySelector(this.noResultsCodeSelector);
    postcodeElement.innerHTML = this.postcode;
}

export function toggleNoResultsMsg() {
    const postcodeElement = document.querySelector(this.noResultsCodeSelector);
    const parent = postcodeElement.parentElement;
    if (this.noResults === true) parent.style.display = "block";
    else parent.style.display = "none";
}

export function clearMarkers() {
    this.markers.forEach((marker) => {
        marker.setMap(null);
    });
    this.markers = [];
}

export function clearCountries() {
    this.countries.forEach((country) => {
        country.setMap(null);
    });
    this.countries = [];
}

export function getIcons(config: any, maps: any) {
    return {
        logo: {
            url: config?.logo_icon,
            size: new maps.Size(30, 30),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(15, 15),
        },
        gray: {
            url: config?.gray_icon,
            scaledSize: new maps.Size(36, 40),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(16.2, 36),
        },
        blue: {
            url: config?.blue_icon,
            scaledSize: new maps.Size(36, 40),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(17, 36),
        },
        green: {
            url: config?.green_icon,
            scaledSize: new maps.Size(56, 60),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(25.2, 54),
        },
        gray_hover: {
            url: config?.gray_icon,
            scaledSize: new maps.Size(56, 60),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(25.2, 54),
        },
        blue_hover: {
            url: config?.blue_icon,
            scaledSize: new maps.Size(56, 60),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(25.2, 54),
        },
        green_hover: {
            url: config?.green_icon,
            scaledSize: new maps.Size(76, 80),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(34.2, 72),
        },
        jump_to_other_country: {
            url: config?.globe_icon,
            size: new maps.Size(56, 56),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(28, 28),
        },
        jump_to_other_country_hover: {
            url: config?.globe_icon_hover,
            size: new maps.Size(56, 56),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(15, 15),
        },
    };
}

export function setMarkers({ withCountries }) {
    const icons = getIcons(this.config, this.maps);
    this.clearMarkers();
    this.clearCountries();
    if (this.apiResponse.location.length === 0) return;
    const maxZoomLevel = 14;
    const markerBounds = new this.maps.LatLngBounds();
    this.apiResponse.location.forEach((location, index) => {
        this.markers[index] = new this.maps.Marker({
            position: location.lat_lng,
            map: this.map,
            icon: icons[location.type],
            url: location.link,
            zIndex: location.type === "green" ? 10 : 1,
        });
        markerBounds.extend(location.lat_lng);
        this.map.fitBounds(markerBounds);
        if (this.map.getZoom() > maxZoomLevel) {
            this.map.setZoom(maxZoomLevel);
        }
        this.maps.event.addListener(this.markers[index], "mouseover", () => {
            highlightMarker(
                index,
                this.map,
                this.locationSlider,
                this.markers,
                icons,
                location.type,
                false
            );
        });
        this.maps.event.addListener(this.markers[index], "mouseout", () => {
            deHighlightMarker(
                index,
                this.markers,
                this.locationSlider,
                location.type,
                icons
            );
        });
        if (location.link) {
            this.maps.event.addListener(
                this.markers[index],
                "click",
                function () {
                    window.location.href = location.link;
                }
            );
        }
        setTimeout(() => {
            const slides = this.locationSlider.querySelectorAll(
                "ux-slider-slide"
            );
            slides[index].addEventListener("mouseover", () => {
                highlightMarker(
                    index,
                    this.map,
                    this.locationSlider,
                    this.markers,
                    icons,
                    location.type,
                    true
                );
            });
            slides[index].addEventListener("mouseout", () => {
                deHighlightMarker(
                    index,
                    this.markers,
                    this.locationSlider,
                    location.type,
                    icons
                );
            });
        }, 1000);
    });
    if (withCountries === true) {
        this.apiResponse.countries.forEach((country, index) => {
            this.countries[index] = new this.maps.Marker({
                position: country.lat_lng,
                map: this.map,
                icon: icons["jump_to_other_country"],
                url: country.link,
                zIndex: 1,
            });

            const infowindow = new this.maps.InfoWindow({
                content: country.name,
            });

            this.maps.event.addListener(
                this.countries[index],
                "mouseover",
                () => {
                    infowindow.open(this.map, this.countries[index]);
                }
            );
            this.maps.event.addListener(
                this.countries[index],
                "mouseout",
                () => {
                    infowindow.close(this.map, this.countries[index]);
                }
            );
            this.maps.event.addListener(this.countries[index], "click", () => {
                window.location.href = country.link;
            });
        });
    }
}

export const highlightMarker = (
    index,
    map,
    slider,
    markers,
    icons,
    locationtype,
    centerMap
) => {
    const newIcon = locationtype + "_hover";
    const marker = markers[index];

    if (marker) {
        marker.setIcon(icons[newIcon]);
        marker.setZIndex(15);
    }

    if (centerMap) {
        if (map && marker) map.panTo(marker.position);
        highlightElement(slider, index);
    } else {
        slider.slideTo(index, 400);
        highlightElement(slider, index);
    }
};

export const deHighlightMarker = (
    index,
    markers,
    slider,
    locationtype,
    icons
) => {
    markers[index].setIcon(icons[locationtype]);
    if (locationtype === "green") {
        markers[index].setZIndex(10);
    } else {
        markers[index].setZIndex(1);
    }
    const slides = slider.querySelectorAll("ux-slider-slide");
    slides.forEach((slide) => {
        slide.classList.remove("slide-disabled");
    });
};

const highlightElement = (slider, activeIndex) => {
    const slides = slider.querySelectorAll("ux-slider-slide");
    slides.forEach((slide, index) => {
        if (
            index !== activeIndex &&
            !slide.classList.contains("slide-disabled")
        ) {
            slide.classList.add("slide-disabled");
        } else if (
            index === activeIndex &&
            slide.classList.contains("slide-disabled")
        ) {
            slide.classList.remove("slide-disabled");
        }
    });
};
